<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.00002 12.9995L17.17 12.9995L14.29 15.8795C13.9 16.2695 13.9 16.8995 14.29 17.2895C14.68 17.6795 15.31 17.6795 15.7 17.2895L20.29 12.6995C20.68 12.3095 20.68 11.6795 20.29 11.2895L15.7 6.69953C15.31 6.30953 14.68 6.30953 14.29 6.69953C13.9 7.08953 13.9 7.71953 14.29 8.10953L17.17 10.9995L4.00002 10.9995C3.45002 10.9995 3.00002 11.4495 3.00002 11.9995C3.00002 12.5495 3.45002 12.9995 4.00002 12.9995Z" fill="white"/>
    </svg>
</template>

<script>
export default {
    name: "ArrowNoticeIcon"
}
</script>

<style scoped>

</style>